import { __assign } from "tslib";
import cns from 'classnames';
import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { usePrefix } from '../ConfigProvider';
import { useDropdownCtx } from '../Dropdown';
import { concat } from '../utils';
var menuCtx = createContext({
    hideDropdownOnItemClick: true
});
export function Menu(_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.hideDropdownOnItemClick, hideDropdownOnItemClick = _c === void 0 ? true : _c, classNameFromProps = _a.className, style = _a.style, rootHtmlProps = _a.rootHtmlProps;
    var prefix = usePrefix('menu');
    var className = cns(prefix, concat(prefix, 'size', size), classNameFromProps, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var ctxValue = useMemo(function () { return ({ hideDropdownOnItemClick: hideDropdownOnItemClick }); }, [hideDropdownOnItemClick]);
    return (React.createElement(menuCtx.Provider, { value: ctxValue },
        React.createElement("div", __assign({}, rootHtmlProps, { className: className, style: style }),
            React.createElement(MenuList, null, children))));
}
export function MenuItem(_a) {
    var children = _a.children, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, classNameFromProps = _a.className, style = _a.style, rootHtmlProps = _a.rootHtmlProps;
    var prefix = concat(usePrefix('menu'), 'item');
    var className = cns(prefix, active && concat(prefix, 'active'), disabled && concat(prefix, 'disabled'), classNameFromProps, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var hideDropdownOnItemClick = useContext(menuCtx).hideDropdownOnItemClick;
    var dropdownCtx = useDropdownCtx();
    var handleClick = useCallback(function (e) {
        var _a;
        if (disabled)
            return;
        (_a = rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rootHtmlProps, e);
        if (e.defaultPrevented)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (dropdownCtx && hideDropdownOnItemClick) {
            dropdownCtx.setVisible(false);
        }
    }, [disabled, onClick, rootHtmlProps, hideDropdownOnItemClick, dropdownCtx]);
    return (React.createElement("li", __assign({}, rootHtmlProps, { className: className, style: style, onClick: handleClick }), children));
}
export function MenuItemGroup(_a) {
    var title = _a.title, children = _a.children, classNameFromProps = _a.className, style = _a.style, rootHtmlProps = _a.rootHtmlProps;
    var prefix = concat(usePrefix('menu'), 'item', 'group');
    var className = cns(prefix, classNameFromProps, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    return (React.createElement("li", __assign({}, rootHtmlProps, { className: className, style: style }),
        React.createElement("h5", { className: concat(className, 'title') }, title),
        React.createElement(MenuList, null, children)));
}
function MenuList(_a) {
    var children = _a.children;
    var prefix = usePrefix('menu');
    return (React.createElement("ul", { className: concat(prefix, 'list') }, children));
}
//# sourceMappingURL=index.js.map